<template>
	<div ref="w" class="dateonlypicker-container">
		<div class="picker">
			<el-date-picker
				ref="dp"
				v-model="userDateModel"
				type="date"
				placeholder=""
				:size="size"
				:clearable="true"
				format="DD.MM.YYYY"
				value-format="YYYY-MM-DD"
				@change="onDatePicked"
			/>
		</div>
		<div class="button" v-if="clearable">
			<el-link :underline="false" :icon="cancelIcon" @click="onCancelClick" />
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Close } from '@element-plus/icons-vue';
import { watch, WatchStopHandle } from 'vue';

@Options({	
	props: {
		modelValue: String,
		size: {
			type: String,
			default: 'default'
		},
		clearable: {
			type: Boolean,
			default: false
		}
	},
	emits: ['update:modelValue', 'canceled']
})
export default class DateOnlyPickerComponent extends Vue {
	/** props */
	modelValue!: string;
	size!: string;
	clearable!: boolean;

	/** constants */
	cancelIcon = Close;

	/** view-models */
	userDateModel: string | null = null;

	dateWatchSubscription?: WatchStopHandle;

	mounted() {
		this.dateWatchSubscription = watch(
			() => this.modelValue,
			v => {
				if (!v) {
					this.userDateModel = null;
					return;
				}				
				this.userDateModel = v;
			});

		if (this.modelValue) {
			this.userDateModel = this.modelValue;
		}

		this.$nextTick()
			.then(() => {
				const wrapper = this.$refs.w as HTMLElement;
				const dateInput = wrapper.querySelector("input") as HTMLElement;

				if (!dateInput) {
					console.warn('Unable to find el-date-picker date input element');
					return;
				}

				dateInput.addEventListener('keyup', this.onKeyUp)
			});
	}

	unmounted(): void {
		if (this.dateWatchSubscription) {
			this.dateWatchSubscription();
		}
	}

	onDatePicked(v: string) {
		this.$emit('update:modelValue', v);
	}

	onCancelClick() {
		const datePickerComponent = this.$refs.dp! as any;		
		datePickerComponent?.handleClose();
		this.emitCanceled();
	}

	emitCanceled() {
		this.$emit('canceled');
	}

	onKeyUp(e: KeyboardEvent) {
		const key = e?.key?.toLocaleLowerCase();
		if (!key) {
			return;
		}

		if (key == "enter") {
			const datePickerComponent = this.$refs.dp! as any;
			datePickerComponent.handleClose();
			this.$emit('update', this.userDateModel);
		} else if (key == "escape") {
			const datePickerComponent = this.$refs.dp! as any;
			datePickerComponent.handleClose();
			this.emitCanceled();
		}
	}
}
</script>

<style>
.dateonlypicker-container {
	display: flex;
	align-items: stretch;
}

	.dateonlypicker-container .picker {
		flex: 80%;	
	}

		.dateonlypicker-container .picker > div {
			width: unset!important;
		}

	.dateonlypicker-container .button {
		flex: 20%;	
	}
</style>